import { render, staticRenderFns } from "./DocumentCreate.vue?vue&type=template&id=7e4af01e&"
import script from "./DocumentCreate.vue?vue&type=script&lang=js&"
export * from "./DocumentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports